import { IController } from 'angular';
import * as _ from 'lodash';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';

import { GraduationPlanTransfer } from '../../../../../../../ng2/shared/constants/graduation-plan-transfer.constant';
import { WizardUtils } from './../../../../../../shared/services/wizard-utils/wizard-utils.service';

export class NotOnTargetCtrl implements IController {
  static inject: string[] = ['$scope', 'ImSchool', 'WizardUtils'];

  private school;
  private nextFourGradDates;
  private filteredStudents;
  public notOnTarget;
  public filterOptions;

  constructor(public $scope, private ImSchool: ImSchool, private WizardUtils: WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi() {
    this.filterOptions = { columnKeys: ['gradPlan', 'plannedDiplomaType', 'plannedGraduationDate'] };
    this.filteredStudents = this.WizardUtils.getFilteredFlattenedStudents();
    this.school = this.WizardUtils.getCurrentSdcSchool();
    this.nextFourGradDates = this.ImSchool.getNextFourGradDatesForTransfer();
    this.notOnTarget = this.getStudentsNotGraduatingInNext4Terms();
  }

  private getStudentsNotGraduatingInNext4Terms() {
    const nextFourGradDates = _.map(this.nextFourGradDates, (gradDate: any) => gradDate.humanName);
    return _.reduce(
      this.filteredStudents,
      (result, student: any) => {
        const { studentId } = student;
        const calculatedGradPlan: any = _.find(GraduationPlanTransfer, { humanName: student.calculatedGradPlan });
        if (!calculatedGradPlan) return result;
        if (calculatedGradPlan.diploma && !_.includes(nextFourGradDates, calculatedGradPlan.date))
          result.push(studentId);
        return result;
      },
      [],
    );
  }
}
